import { Badge } from '@plato/ui-legacy/components/list-views/badge';
import { CollapsibleText } from '@plato/ui-legacy/components/ui/collapsible-text';
import Text from '@plato/ui-legacy/components/ui/text';
import { UserCheck, UserX } from 'lucide-react';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import type { CrmCustomerStatusChangeDTO } from '../../../server/dto/crm-customer-status-change-dto.ts';
import type { ActivityFeedRecord } from '../../../server/types/customer-activity-feed-types.ts';
import { RichTextViewer } from '../../rich-text/components/rich-text-viewer.tsx';
import { TimelineList } from '../../shared/components/timeline-list/timeline-list.tsx';

export const ActivityFeedCustomerStatusChangeItem = React.forwardRef<
    HTMLDivElement,
    { activity: ActivityFeedRecord }
>(({ activity }, ref) => {
    const { t } = useTranslation('activity-feed');
    const statusChange = activity.payload as CrmCustomerStatusChangeDTO;

    const isMarkedInactive = statusChange.toStatus === 'inactive';
    const Icon = isMarkedInactive ? UserX : UserCheck;

    return (
        <TimelineList.Item icon={Icon} ref={ref} role="article">
            <TimelineList.ItemHeader>
                <div className="flex w-full items-center justify-between gap-2">
                    <Text>
                        <Trans
                            i18nKey={
                                isMarkedInactive
                                    ? 'status_change__marked_inactive'
                                    : 'status_change__reactivated'
                            }
                            ns="activity-feed"
                            values={{ user: statusChange.createdBy.fullName }}
                            components={{ strong: <strong className="font-semibold" /> }}
                        />
                    </Text>
                    <Badge color={isMarkedInactive ? 'red' : 'green'}>
                        →
                        {isMarkedInactive
                            ? t('status_change__status_inactive')
                            : t('status_change__status_active')}
                    </Badge>
                </div>
            </TimelineList.ItemHeader>
            <TimelineList.ItemBody>
                <div className="flex flex-col gap-2">
                    {statusChange.reasonRich && (
                        <CollapsibleText>
                            <RichTextViewer content={statusChange.reasonRich} />
                        </CollapsibleText>
                    )}
                </div>
            </TimelineList.ItemBody>
        </TimelineList.Item>
    );
});

ActivityFeedCustomerStatusChangeItem.displayName = 'ActivityFeedCustomerStatusChangeItem';
